import { fetchApi } from 'Utils/utils';

export const findAll = () => fetchApi.get('/api/v1/productClass/all/');
export const findById = id => fetchApi.get(`/api/v1/productClass/${id}/`);
export const create = payload => fetchApi.post('/api/v1/productClass/', payload);
export const update = (id, payload) => fetchApi.put(`/api/v1/productClass/${id}/`, payload);
export const remove = id => fetchApi.delete(`/api/v1/productClass/${id}/`);
export const search = payload => fetchApi.post('/api/v1/productClass/search/', payload);
